import React, { Component } from 'react';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../styles/ReactQuill.css';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';
import { scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';

var config = process.env;

class EditEmailTemplatePage extends Component {

    constructor() {
        super();
        this.state = {
            checked: false,
            role: Number(localStorage.getItem('role') || 0),
            templateKey: '',
            subject: '',
            body_html: '',
            variables: [],
            previewHtml: '',
            lastFocus: 'body',
            saving: false,
            sending: false,
        };
    }

    async componentDidMount() {
        const role = await validateSession();
        const templateKey = this.props.match.params.key;
        this.setState({ checked: true, role: role, templateKey: templateKey });
        this.loadTemplate(templateKey);
        this.loadVariables(templateKey);
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'previewTimeout');
    }

    authHeaders() {
        return {
            'access-token': localStorage.getItem('token'),
            'Content-Type': 'application/json',
        };
    }

    handleApiError(data) {
        alert(data.message);
        if (data.error == 1002) {
            window.location.href = localStorage.getItem('homePageURL');
        }
    }

    loadTemplate = (templateKey) => {
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'emailTemplate/detail?key=' + encodeURIComponent(templateKey), { method: 'GET', headers: this.authHeaders() })
            .then(r => r.json())
            .then(data => {
                // 6300 = no existe todavía: se empieza en blanco (el PUT la crea).
                if (data.error > 0 && data.error != 6300) {
                    this.handleApiError(data);
                    return;
                }
                const tpl = (data.data && data.data.template) || {};
                this.setState({ subject: tpl.subject || '', body_html: tpl.body_html || '' }, this.schedulePreview);
            });
    }

    loadVariables = (templateKey) => {
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'emailTemplate/variables?event=' + encodeURIComponent(templateKey), { method: 'GET', headers: this.authHeaders() })
            .then(r => r.json())
            .then(data => {
                if (data.error > 0) { this.handleApiError(data); return; }
                this.setState({ variables: (data.data && data.data.variables) || [] });
            });
    }

    schedulePreview = () => {
        scheduleDebouncedCallback(this, 'previewTimeout', () => this.fetchPreview());
    }

    fetchPreview = () => {
        var request = {
            method: 'POST',
            headers: this.authHeaders(),
            body: JSON.stringify({ template_key: this.state.templateKey, subject: this.state.subject, body_html: this.state.body_html }),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'emailTemplate/preview', request)
            .then(r => r.json())
            .then(data => {
                if (data.error > 0) { this.handleApiError(data); return; }
                this.setState({ previewHtml: (data.data && data.data.html) || '' });
            });
    }

    onChangeSubject = (e) => {
        this.setState({ subject: e.target.value }, this.schedulePreview);
    }

    onChangeBody = (html) => {
        this.setState({ body_html: html }, this.schedulePreview);
    }

    insertVariable = (name) => {
        const token = '{{' + name + '}}';
        if (this.state.lastFocus === 'subject') {
            this.setState({ subject: (this.state.subject || '') + token }, this.schedulePreview);
        } else {
            this.setState({ body_html: (this.state.body_html || '') + ' ' + token }, this.schedulePreview);
        }
    }

    onTestSend = () => {
        this.setState({ sending: true });
        var request = {
            method: 'POST',
            headers: this.authHeaders(),
            body: JSON.stringify({ template_key: this.state.templateKey, subject: this.state.subject, body_html: this.state.body_html }),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'emailTemplate/test-send', request)
            .then(r => r.json())
            .then(data => {
                this.setState({ sending: false });
                if (data.error > 0) {
                    if (data.error == 6302) { alert('Límite de envíos de prueba alcanzado. Probá de nuevo más tarde.'); return; }
                    this.handleApiError(data);
                    return;
                }
                alert('Prueba enviada a ' + ((data.data && data.data.to) || 'tu email'));
            });
    }

    onSave = () => {
        if (!this.state.subject || !this.state.body_html) {
            alert('El asunto y el cuerpo son obligatorios.');
            return;
        }
        this.setState({ saving: true });
        var request = {
            method: 'PUT',
            headers: this.authHeaders(),
            body: JSON.stringify({ subject: this.state.subject, body_html: this.state.body_html }),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'emailTemplate?key=' + encodeURIComponent(this.state.templateKey), request)
            .then(r => r.json())
            .then(data => {
                if (data.error > 0) { this.setState({ saving: false }); this.handleApiError(data); return; }
                navigateTo('/emailTemplates');
            });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={18} role={this.state.role}/>
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Comunicaciones" subtitle={'Editar plantilla: ' + this.state.templateKey}/>
                            <div className="row">
                                {/* Editor */}
                                <div className="col-lg-7">
                                    <div className="card card-small mb-4">
                                        <div className="card-header border-bottom">
                                            <h6 className="m-0">Contenido</h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="form-group">
                                                <label htmlFor="subject">Asunto</label>
                                                <input
                                                    id="subject"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Asunto del email"
                                                    value={this.state.subject}
                                                    onFocus={() => this.setState({ lastFocus: 'subject' })}
                                                    onChange={this.onChangeSubject}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Cuerpo</label>
                                                <ReactQuill
                                                    value={this.state.body_html}
                                                    placeholder="Contenido del email"
                                                    onFocus={() => this.setState({ lastFocus: 'body' })}
                                                    onChange={this.onChangeBody}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Paleta de variables */}
                                    <div className="card card-small mb-4">
                                        <div className="card-header border-bottom">
                                            <h6 className="m-0">Variables disponibles</h6>
                                        </div>
                                        <div className="card-body">
                                            <p className="text-muted" style={{ fontSize: '0.8rem' }}>
                                                Clic para insertar en el último campo enfocado (asunto o cuerpo).
                                            </p>
                                            {this.state.variables.map((v) => (
                                                <button
                                                    key={v.name}
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm mr-2 mb-2"
                                                    title={(v.description || '') + (v.example ? (' — ej: ' + v.example) : '')}
                                                    onClick={() => this.insertVariable(v.name)}
                                                >
                                                    {'{{' + v.name + '}}'}{v.required ? ' *' : ''}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <button type="button" className="btn btn-primary mr-2" disabled={this.state.saving} onClick={this.onSave}>
                                            {this.state.saving ? 'Guardando...' : 'Guardar'}
                                        </button>
                                        <button type="button" className="btn btn-outline-info mr-2" disabled={this.state.sending} onClick={this.onTestSend}>
                                            {this.state.sending ? 'Enviando...' : 'Enviarme una prueba'}
                                        </button>
                                        <button type="button" className="btn btn-outline-secondary" onClick={() => navigateTo('/emailTemplates')}>
                                            Cancelar
                                        </button>
                                    </div>
                                </div>

                                {/* Preview */}
                                <div className="col-lg-5">
                                    <div className="card card-small mb-4">
                                        <div className="card-header border-bottom">
                                            <h6 className="m-0">Vista previa</h6>
                                        </div>
                                        <div className="card-body p-2">
                                            <div className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
                                                <b>Asunto:</b> {this.state.subject}
                                            </div>
                                            <iframe
                                                title="preview"
                                                sandbox=""
                                                srcDoc={this.state.previewHtml}
                                                style={{ width: '100%', height: '520px', border: '1px solid #e1e5eb', borderRadius: '0.375rem', background: '#fff' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default EditEmailTemplatePage;
